import BaseModel from './BaseModel'

export default class PropositionOptionModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      LIBELLE: '',
      TEXTE: '',
      TARIF: '',
      FORCEE: 0,
      CODE_REF_TYPE_OPTION: '',
      NB_CREDITS_OPTION_PAC: ''
    }
    super(data, relation, fields)
  }
}
